export const GET_ALL_STATIONS_DATA = process.env.REACT_APP_ALL_STATIONS_API;
export const GET_ALL_STATIONS_IMGS = process.env.REACT_APP_STATION_IMAGES;
export const POST_CONTACT_FORM = process.env.REACT_APP_POST_CONTACT_FORM;
export const PROMITION_LINK = process.env.REACT_APP_PROMOTION_LINK;
export const STATION_GALLERY = process.env.REACT_APP_STATION_GALLERY;
export const STATIONS_API_URL = "https://kmicro-tech.github.io/StationLocatorImages/Data/stations.json";
export const PAYMENT_METHODS_API_URL = "https://kmicro-tech.github.io/StationLocatorImages/Filter/payments.json";
export const STATION_IMAGES_API_URL = "https://raw.githubusercontent.com/KMicro-Tech/StationLocatorImages/main/stations/photos.json";